<template>
  <v-layout column align-center justify-start class="relative pt-5">
                <div style="width: 100%;height: 130px;background: rgb(236, 236, 236);position: absolute;top: 19px;">
					<v-icon style="font-size: 158px;color: rgb(250, 251, 251);position: absolute;right: 9px;bottom: -27px;">star_border</v-icon>
                </div>




        <!-- no favorites message -->
    <div class="display-1 grey--text text--darken-2" style="margin-top: 30px;position: relative;z-index: 5">
       Coming Soon... Word!
    </div>

            </v-layout>
</template>

<style>
.icon-button-shadow {
	text-shadow: 2px 2px 6px #15b68187;
}

.lang-selector .v-input__control {
	min-width:350px;
}
</style>

<script>
import lingo_audio from './AudioPlayer';

  export default {
    name: 'lingo_favorites',
   data () {
      return {
        voices: ['Male', 'Female'],
        intonation: ['Even', 'Excited', 'Sad'],
        items: [
          { header: 'You have 3 favorite voices' },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
            title: 'Phone Booth Voice',
            subtitle: "<span class='text--primary'>John</span> &mdash; English, Regular"
          },
          { divider: true, inset: true },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
            title: 'Commercial Voice',
            subtitle: "<span class='text--primary'>Michelle</span> &mdash; French, Excited"
          },
          { divider: true, inset: true },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
            title: 'Elevator Voice',
            subtitle: "<span class='text--primary'>John</span> &mdash; Spannish, Regular"
          }
        ],
      file: 'https://ia802508.us.archive.org/5/items/testmp3testfile/mpthreetest.mp3'
      }
    },
    methods : {
		useVoice () {
			this.$store.commit('setSelectedLanguageByCode', 'en-AU');
			this.$store.commit('setSelectedCharacter', 'en-AU-Standard-D');
			this.$router.push({path: '/app/audio_generator'});
		}
	},
    components: {
		lingo_audio
    }
  }
</script>
